import React, { useState, useEffect } from 'react';
import UDIRowPopup, { UDIPopupField, UDIAddRowButton, useUDIRowPopup } from './UDIRowPopup.js';

const StorageAndHandling = ({
    UDI,
    setUDI,
    initialData = '[]',
    hiddenFieldName = "Form.USProductUDI.StorageAndHandling",
    fieldTitle = "Storage And Handling",
    forceIsEditing = null
}) => {
    // Parse initial data from Razor
    const [items, setItems] = useState(() => {
        try {
            return (typeof initialData === 'string' ? JSON.parse(initialData) : initialData) || [];
        } catch {
            return [];
        }
    });

    const initialFormState = {
        StorageAndHandlingType: 'Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure',
        StorageAndHandlingUnitOfMeasure: 'Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure - kPa',
        StorageAndHandlingLowValue: '',
        StorageAndHandlingHighValue: '',
        StorageAndHandlingSpecialStorageConditions: ''
    };

    const [isEditing, setIsEditing] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [formData, setFormData] = useState(initialFormState);
    const [editingIndex, setEditingIndex] = useState(null);

    // Logic: Show special conditions textarea only for specific type
    const isSpecialConditions = formData.StorageAndHandlingType === "Storage and Handling Units of Measure - Special Storage Conditions";

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        let itemToSave = { ...formData };

        // Clean up fields based on the selected type
        if (isSpecialConditions) {
            itemToSave.StorageAndHandlingUnitOfMeasure = "";
            itemToSave.StorageAndHandlingLowValue = "";
            itemToSave.StorageAndHandlingHighValue = "";
        } else {
            itemToSave.StorageAndHandlingSpecialStorageConditions = "";
        }

        const updatedItems = [...items];
        if (editingIndex !== null) {
            updatedItems[editingIndex] = itemToSave;
        } else {
            updatedItems.push(itemToSave);
        }

        // 1. Update local state
        setItems(updatedItems);

        // 2. Update Global (Nested spread)
        setUDI(prevItem => ({
            ...prevItem,
            StorageAndHandling: updatedItems
        }));

        popup.close();
    };

    const handleRemove = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);

        setItems(updatedItems);

        setUDI(prevItem => ({
            ...prevItem,
            StorageAndHandling: updatedItems
        }));

        resetForm();
    };

    const handleEdit = (index) => {
        setFormData(items[index]);
        setEditingIndex(index);
        popup.openEdit();
    };

    const resetForm = () => {
        setFormData(initialFormState);
        setEditingIndex(null);
    };

    const popup = useUDIRowPopup(resetForm);


    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditing(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);

    }, [forceIsEditing]);



    return (


        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>

                        {isEditing ?

                            <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Unit of Measure</th>
                                            <th>Low Value</th>
                                            <th>High Value</th>
                                            <th>Special Storage Conditions</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr
                                                key={index}
                                                className={editingIndex === index ? 'udi-complex-field-row-selected' : ''}
                                            >
                                                <td>{item.StorageAndHandlingType}</td>
                                                <td>{item.StorageAndHandlingUnitOfMeasure}</td>
                                                <td>{item.StorageAndHandlingLowValue}</td>
                                                <td>{item.StorageAndHandlingHighValue}</td>
                                                <td style={{ whiteSpace: 'pre-wrap' }}>{item.StorageAndHandlingSpecialStorageConditions}</td>
                                                <td>
                                                    <button type="button" className="udiEditButton" onClick={() => handleEdit(index)}>
                                                        <i className="fas fa-edit"></i>
                                                    </button>
                                                    <button type="button" className="udiRemoveButton" onClick={() => handleRemove(index)}>
                                                        <i className="fas fa-times-circle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <UDIAddRowButton label="Add Storage And Handling Requirement" onClick={popup.openAdd} />

                                <UDIRowPopup
                                    isOpen={popup.isOpen}
                                    title={editingIndex !== null ? "Edit Storage And Handling Requirement" : "Add Storage And Handling Requirement"}
                                    saveLabel={editingIndex !== null ? "Save" : "Add"}
                                    onClose={popup.close}
                                    onSave={handleSave}
                                >
                                    Storage And Handling Type: <br />
                                    <select
                                        name="StorageAndHandlingType"
                                        value={formData.StorageAndHandlingType}
                                        onChange={handleInputChange}
                                    >
                                        <option value="Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure">Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure</option>
                                        <option value="Storage Environment Humidity - Storage Environment Humidity">Storage Environment Humidity - Storage Environment Humidity</option>
                                        <option value="Storage Environment Temperature - Storage Environment Temperature">Storage Environment Temperature - Storage Environment Temperature</option>
                                        <option value="Storage and Handling Units of Measure - Handling Environment Atmospheric Pressure">Storage and Handling Units of Measure - Handling Environment Atmospheric Pressure</option>
                                        <option value="Storage and Handling Units of Measure - Handling Environment Humidity">Storage and Handling Units of Measure - Handling Environment Humidity</option>
                                        <option value="Storage and Handling Units of Measure - Handling Environment Temperature">Storage and Handling Units of Measure - Handling Environment Temperature</option>
                                        <option value="Storage and Handling Units of Measure - Special Storage Conditions">Storage and Handling Units of Measure - Special Storage Conditions</option>
                                    </select>
                                    <br /><br />

                                    {!isSpecialConditions ? (
                                        <div>
                                            Unit of Measure: <br />
                                            <select
                                                name="StorageAndHandlingUnitOfMeasure"
                                                value={formData.StorageAndHandlingUnitOfMeasure}
                                                onChange={handleInputChange}
                                            >
                                                <option value="Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure - kPa">Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure - kPa</option>
                                                <option value="Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure - mbar">Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure - mbar</option>
                                                <option value="Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure - in[Hg]">Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure - in[Hg]</option>
                                                <option value="Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure - mm[Hg]">Storage Environment Atmospheric Pressure - Storage Environment Atmospheric Pressure - mm[Hg]</option>
                                                <option value="Storage Environment Humidity - Storage Environment Humidity - Percent">Storage Environment Humidity - Storage Environment Humidity - Percent</option>
                                                <option value="Storage Environment Temperature - Storage Environment Temperature - Cel">Storage Environment Temperature - Storage Environment Temperature - Cel</option>
                                                <option value="Storage Environment Temperature - Storage Environment Temperature - [degf]">Storage Environment Temperature - Storage Environment Temperature - [degf]</option>
                                                <option value="Storage Environment Temperature - Storage Environment Temperature - K">Storage Environment Temperature - Storage Environment Temperature - K</option>
                                                <option value="Storage and Handling Units of Measure - Handling Environment Atmospheric Pressure - kPa">Storage and Handling Units of Measure - Handling Environment Atmospheric Pressure - kPa</option>
                                                <option value="Storage and Handling Units of Measure - Handling Environment Atmospheric Pressure - mbar">Storage and Handling Units of Measure - Handling Environment Atmospheric Pressure - mbar</option>
                                                <option value="Storage and Handling Units of Measure - Handling Environment Atmospheric Pressure - in[Hg]">Storage and Handling Units of Measure - Handling Environment Atmospheric Pressure - in[Hg]</option>
                                                <option value="Storage and Handling Units of Measure - Handling Environment Atmospheric Pressure - mm[Hg]">Storage and Handling Units of Measure - Handling Environment Atmospheric Pressure - mm[Hg]</option>
                                                <option value="Storage and Handling Units of Measure - Handling Environment Humidity - Percent">Storage and Handling Units of Measure - Handling Environment Humidity - Percent</option>
                                                <option value="Storage and Handling Units of Measure - Handling Environment Temperature - Cel">Storage and Handling Units of Measure - Handling Environment Temperature - Cel</option>
                                                <option value="Storage and Handling Units of Measure - Handling Environment Temperature - [degf]">Storage and Handling Units of Measure - Handling Environment Temperature - [degf]</option>
                                                <option value="Storage and Handling Units of Measure - Handling Environment Temperature - K">Storage and Handling Units of Measure - Handling Environment Temperature - K</option>
                                            </select>
                                            <br /><br />
                                            Low Value: <br />
                                            <input type="text" name="StorageAndHandlingLowValue" value={formData.StorageAndHandlingLowValue} onChange={handleInputChange} />
                                            <br /><br />
                                            High Value: <br />
                                            <input type="text" name="StorageAndHandlingHighValue" value={formData.StorageAndHandlingHighValue} onChange={handleInputChange} />
                                            <br /><br />
                                        </div>
                                    ) : (
                                        <div>
                                            Special Storage Conditions: <br />
                                            <textarea
                                                name="StorageAndHandlingSpecialStorageConditions"
                                                value={formData.StorageAndHandlingSpecialStorageConditions}
                                                onChange={handleInputChange}
                                            />
                                            <br /><br />
                                        </div>
                                    )}
                                </UDIRowPopup>

                                <input type="hidden" name={hiddenFieldName} value={JSON.stringify(items)} />
                            </div>


                            :


                            <>

                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Unit of Measure</th>
                                            <th>Low Value</th>
                                            <th>High Value</th>
                                            <th>Special Storage Conditions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr
                                                key={index}
                                                className={editingIndex === index ? 'udi-complex-field-row-selected' : ''}
                                            >
                                                <td>{item.StorageAndHandlingType}</td>
                                                <td>{item.StorageAndHandlingUnitOfMeasure}</td>
                                                <td>{item.StorageAndHandlingLowValue}</td>
                                                <td>{item.StorageAndHandlingHighValue}</td>
                                                <td style={{ whiteSpace: 'pre-wrap' }}>{item.StorageAndHandlingSpecialStorageConditions}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/*
                                <input
                                    type="button"
                                    className="udiActionButton"
                                    value="Edit"
                                    onClick={() => changeIsEditingField(true)}
                                />
                                */}
                            </>

                        }

                    </div>

                </div>
            </div>
        </div>






    );
};

export default StorageAndHandling;